import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { makeLookupPage } from './components/common/LookupPage';
import { lookupApi } from './api';

import Layout         from './components/layout/Layout';
import LoginPage      from './pages/LoginPage';
import DashboardPage  from './pages/DashboardPage';
import SuppliersPage  from './pages/SuppliersPage';
import BrandsPage     from './pages/BrandsPage';
import ItemsPage      from './pages/ItemsPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import GrnPage        from './pages/GrnPage';
import PurchaseReturnPage from './pages/PurchaseReturnPage';
import InvoicesPage   from './pages/InvoicesPage';
import DeliveryPage   from './pages/DeliveryPage';
import SalesReturnPage from './pages/SalesReturnPage';
import UsersPage      from './pages/UsersPage';

// Auto-generated lookup pages
const StatusPage  = makeLookupPage({ title: 'Status',    fetchFn: lookupApi.statuses, createFn: lookupApi.createStatus,  updateFn: lookupApi.updateStatus,  deleteFn: lookupApi.deleteStatus,  fieldKey: 'status',          fieldLabel: 'Status Name' });
const CourierPage = makeLookupPage({ title: 'Courier',   fetchFn: lookupApi.couriers, createFn: lookupApi.createCourier, updateFn: lookupApi.updateCourier, deleteFn: lookupApi.deleteCourier, fieldKey: 'courier_name',    fieldLabel: 'Courier Name' });
const ColorsPage  = makeLookupPage({ title: 'Subcategory/Color', fetchFn: lookupApi.colors, createFn: lookupApi.createColor, updateFn: lookupApi.updateColor, deleteFn: lookupApi.deleteColor, fieldKey: 'color_variation', fieldLabel: 'Color / Variation' });

function RequireAuth({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function RequireAdmin({ children }) {
  const { user } = useAuth();
  return user?.role === 'admin' ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
            <Route index           element={<DashboardPage />} />
            <Route path="suppliers" element={<SuppliersPage />} />
            <Route path="brands"    element={<RequireAdmin><BrandsPage /></RequireAdmin>} />
            <Route path="items"     element={<ItemsPage />} />
            <Route path="purchase-orders"  element={<PurchaseOrdersPage />} />
            <Route path="grn"              element={<GrnPage />} />
            <Route path="purchase-returns" element={<PurchaseReturnPage />} />
            <Route path="invoices"         element={<InvoicesPage />} />
            <Route path="deliveries"       element={<DeliveryPage />} />
            <Route path="sales-returns"    element={<SalesReturnPage />} />
            {/* Admin-only settings */}
            <Route path="status"   element={<RequireAdmin><StatusPage /></RequireAdmin>} />
            <Route path="couriers" element={<RequireAdmin><CourierPage /></RequireAdmin>} />
            <Route path="colors"   element={<RequireAdmin><ColorsPage /></RequireAdmin>} />
            <Route path="users"    element={<RequireAdmin><UsersPage /></RequireAdmin>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
